import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Navigation from "../../components/common/Navigation";
import LinearProgress from "material-ui/LinearProgress";
import Banner from "../../components/common/Banner";
import axios from "axios";


class ItHome extends React.Component {

  constructor(props) {
    super();
    this.state = {options: props.options, employees: [], loading: 1, banner: 'Finance Exits'}
    this.refresh = this.refresh.bind(this);
    this.remove = this.remove.bind(this);
    this.changeBanner = this.changeBanner.bind(this);
  }

  changeBanner(name) {
    this.setState({banner: name})
  }

  remove(empId) {

    this.props.refresh();

    let index = -1;
    this.state.employees.map((node, id)=> {
      if (node.employeeCode == empId)
        index = id;
    });
    let employees = this.state.employees;

    if (index != -1)
      employees.splice(index, 1);
    debugger;
    this.setState({employees: employees});


  }

  refresh(empId) {
    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + empId, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let newEmployee = response.data.data;
      let employees = this.state.employees.map((node)=> {
        if (node.employeeCode == newEmployee.employeeCode)
          return newEmployee;
        else
          return node;
      });
      this.setState({employees: employees, loading: 1})
    }).catch((err)=> {
    });
  }

  componentDidMount() {

  }

  render() {
    return (
      <div>
        <Banner name={this.state.banner}/>
        <div className="container" style={{marginLeft: '10', marginRight: '10', width: '100%'}}>
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div id="tab_content">
                  <Navigation options={this.state.options}/>
                  <div className="tab-content responsive" style={{padding: 0}}>
                    <div role="tabpanel" className="tab-panel">
                      <div className="row clearfix">
                        {this.state.loading == 0 ?
                          <LinearProgress mode="indeterminate" style={{padding: '2px', width: '100%'}}/> :
                          <label></label> }
                        <div className="inner-col-wrap inner-table-wrap ">
                          {React.cloneElement(this.props.children, {
                            changeBanner: this.changeBanner,
                            employees: this.state.employees,
                            constants: this.props.constants,
                            refresh: this.refresh,
                            remove: this.remove
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}


ItHome.defaultProps = {
  options: [
    {
      text: "Exits",
      active: true,
      url: "#/1/finance/exits",
      url2: "#/1/finance"
    },
    {
      text: "OnBoarding",
      active: true,
      url: "#/1/finance/onBoarding",
    },
    {
      text: "OnBoarding-Expected",
      active: true,
      url: "#/1/finance/onBoardingExpected",
    },{
      text: "Leave",
      active: false,
      url: '#/1/finance/leave'
    }

  ]
};
ItHome.propTypes = {
  options: React.PropTypes.array
};

function mapStateToProps(state, ownState) {
  return {
    state: state,
    constants: state.constants
  };

}

function mapDispatchToProps(dispatch) {
  return {};

}

export default connect(mapStateToProps, mapDispatchToProps)(ItHome);




/** WEBPACK FOOTER **
 ** ./src/feature/finance/FinanceHome.js
 **/